// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-iam-access-dialog-access-list-inherited-accesses-table__filters {
  margin-bottom: 8px;
}
.dl-iam-access-dialog-access-list-inherited-accesses-table__table table {
  width: 100%;
}
.dl-iam-access-dialog-access-list-inherited-accesses-table__collection {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: var(--g-color-text-primary);
  -webkit-text-decoration: none;
  text-decoration: none;
}
.dl-iam-access-dialog-access-list-inherited-accesses-table__collection-icon {
  min-width: 16px;
}
.dl-iam-access-dialog-access-list-inherited-accesses-table__collection-title {
  margin-left: 6px;
}
.dl-iam-access-dialog-access-list-inherited-accesses-table__empty {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/IamAccessDialog/AccessList/InheritedAccessesTable/InheritedAccessesTable.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;AAAR;AAIQ;EACI,WAAA;AAFZ;AAMI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kCAAA;EACA,6BAAA;EAAA,qBAAA;AAJR;AAOI;EACI,eAAA;AALR;AAQI;EACI,gBAAA;AANR;AASI;EACI,kBAAA;AAPR","sourcesContent":[".dl-iam-access-dialog-access-list-inherited-accesses-table__filters {\n  margin-bottom: 8px;\n}\n.dl-iam-access-dialog-access-list-inherited-accesses-table__table table {\n  width: 100%;\n}\n.dl-iam-access-dialog-access-list-inherited-accesses-table__collection {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  color: var(--g-color-text-primary);\n  text-decoration: none;\n}\n.dl-iam-access-dialog-access-list-inherited-accesses-table__collection-icon {\n  min-width: 16px;\n}\n.dl-iam-access-dialog-access-list-inherited-accesses-table__collection-title {\n  margin-left: 6px;\n}\n.dl-iam-access-dialog-access-list-inherited-accesses-table__empty {\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
